import apiService from 'config/service';
import { IFeatureFlagrResponse } from './types';

const getUserHasFeature = (featureId: number): Promise<IFeatureFlagrResponse> =>
  apiService.get(`company/check-feature-flag/${featureId}`);

export { getUserHasFeature };
